<template>
  <div>

    <div class="page-title-box">
      <div class="page-title-right">

        <b-form class="form-inline" @submit.prevent="validateAndRefresh">
          <validated-form-input name="booksSerialNo" placeholder="Laekumise number" size="sm"
                                v-model="booksSerialNo" validate="required|numeric" :validator="$validator">
            <button type="submit" class="btn btn-primary btn-sm ml-2" :disabled="processing">
              <i class="mdi mdi-loading mdi-spin mr-1" v-if="processing"></i>
              Uuenda
            </button>
          </validated-form-input>
        </b-form>
      </div>
      <h4 class="page-title">Laekumiste logi</h4>
    </div>

    <div class="card">
      <div class="card-body">
        <table id="transactions-list" class="table table-centered table-sm table-hover table-expandable table-sticky mb-0">
          <thead>
          <tr>
            <th>Imporditud</th>
            <th>Arve</th>
            <th>Laekunud</th>
            <th>Laekumise number</th>
            <th class="text-right">Summa</th>
            <th></th>
          </tr>
          </thead>
          <template v-for="(transaction) in transactions">
            <tbody>
            <tr>
              <td>{{transaction.importedAt | formatDateTime}}</td>
              <td>
                <router-link v-if="transaction.invoiceId" :to="`/invoices/${transaction.invoiceId}`">
                  {{transaction.invoiceNumber}}
                </router-link>
              </td>
              <td>
                <template v-if="transaction.receivedAt">
                  {{transaction.receivedAt | formatDate}}
                </template>
              </td>
              <td>{{transaction.booksSerialNo}}</td>
              <td class="text-right">{{transaction.amount | amountWithCurrency}}</td>
              <td class="py-0 text-right">
                <button v-if="transaction.booksSerialNo" type="button" class="btn btn-sm btn-link" @click="refreshTransaction(transaction.booksSerialNo)">
                  <i class="mdi mdi-refresh"></i> Värskenda
                </button>
              </td>
            </tr>
            </tbody>
          </template>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import gateway from '@/services/gateway'
  import ValidatedFormInput from '../components/ValidatedFormInput'

  export default {
    components: {ValidatedFormInput},
    data() {
      return {
        booksSerialNo: null,
        transactions: [],
        processing: false
      }
    },
    methods: {
      validateAndRefresh() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          this.refreshTransaction(this.booksSerialNo);
        })
      },
      refreshTransaction(booksSerialNo) {
        this.processing = true
        gateway.post(`/transactions/by_serial/${booksSerialNo}/refresh`).then(() => {
          this.$notifications.info(`Laekumine ${booksSerialNo} on uuendatud`)
          this.loadData()
          this.processing = false
        }).catch(r => {
          this.$notifications.error(r.response.data.key)
          this.processing = false
        })
      },
      loadData() {
        gateway.get('/transactions').then(r => this.transactions = r.data)
      }
    },
    created() {
      this.loadData()
    }
  }
</script>
